import ejs from "ejs";
import { left, right } from "fp-ts/Either";
import { Base64 } from "js-base64";
import { errorToString } from "shared/misc";
import { uploadUrl } from "shared/upload";
import { renderSVG } from "uqr";
import { translate } from "./translate.js";
export const DEFAULT_PDF_OPTIONS = {
    paging: "SCALE_TO_FIT",
    height: 11,
    width: 8.5,
};
//TODO rm this whole file
export class EJSTemplateRenderer {
    uploadsUrl;
    constructor(uploadsUrl) {
        this.uploadsUrl = uploadsUrl;
    }
    async render(companyId, html, css, data, translations, preview = false) {
        console.log("[TemplateRenderer] Rendering with EJS...", data);
        const helpers = new OldTemplateHelpers(this.uploadsUrl, companyId, preview);
        const translated = translate(data, translations ?? []);
        try {
            return right('<html><head><style type="text/css">' + css + "</style></head><body>" + ejs.render(html, { ...translated, helpers }) + "</body></html>");
        }
        catch (e) {
            return left(errorToString(e));
        }
    }
}
export const TEMPLATE_IMAGE_SIZES = {
    tiny: [48, 48],
    small: [192, 192],
    medium: [384, 384],
    large: [768, 768],
    huge: [1536, 1536]
};
class OldTemplateHelpers {
    uploadsUrl;
    companyId;
    preview;
    constructor(uploadsUrl, companyId, preview = false) {
        this.uploadsUrl = uploadsUrl;
        this.companyId = companyId;
        this.preview = preview;
    }
    /**
     * Generates SVG code for a QR code.
     * @param data The data to encode.
     * @returns A promise that resolves to the SVG code.
     */
    qrCode(data) {
        if (typeof data !== "string" || data === "") {
            throw new Error("The QR code must be a non blank string.");
        }
        return "data:image/svg+xml;base64," + Base64.encode(renderSVG(data));
    }
    /**
     * Generates a URL for a photo.
     * @param id The ID of the photo.
     * @param size The size of the photo.
     * @returns A promise that resolves to the URL of the photo.
     */
    photo(uploadIn, size) {
        if (size !== undefined) {
            const validSizeString = Object.keys(TEMPLATE_IMAGE_SIZES).map(_ => "\"" + _ + "\"").join(", ");
            if (typeof size !== "string") {
                throw new Error("Size must be a string (" + validSizeString + ").");
            }
            if (!Object.keys(TEMPLATE_IMAGE_SIZES).includes(size)) {
                throw new Error("Invalid size \"" + size + "\". Valid sizes are " + validSizeString + ".");
            }
        }
        const upload = typeof uploadIn === "string" ? { id: uploadIn } : uploadIn;
        if (typeof upload !== "object" || upload === null) {
            throw new TypeError("This upload is not an object (got type " + typeof upload + ").");
        }
        const id = "id" in upload ? upload.id : undefined;
        if (id === undefined) {
            throw new TypeError("This upload does not specify an ID.");
        }
        if (typeof id !== "string") {
            throw new TypeError("This upload ID is not a string (got type " + typeof id + ").");
        }
        if (id === "TEST" || (!id && this.preview)) {
            return "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAAD0lEQVR4AQEEAPv/AAAAAAAEAAFlScNgAAAAAElFTkSuQmCC";
        }
        else {
            if (id === undefined || id === null) {
                throw new TypeError("This photo ID is empty.");
            }
            if (typeof id !== "string") {
                throw new TypeError("This photo ID is not a string (got type " + typeof id + ").");
            }
            if (size === undefined) {
                return uploadUrl(this.uploadsUrl, this.companyId, id).url;
            }
            else {
                return uploadUrl(this.uploadsUrl, this.companyId, id).transform({ width: TEMPLATE_IMAGE_SIZES[size]?.[0], height: TEMPLATE_IMAGE_SIZES[size]?.[1] });
            }
        }
    }
}
